import React from 'react'
import HomePageBannerVideo from '../../../assets/videos/HomePageBannerVideo.mp4'


const Hero = () => {
    return (
        <section className='bg-black relative py-20 px-8 sm:px-[58px] md:px-[68px] lg:px-[90px] xl:px-32'>
            <div className='flex flex-col gap-8 content-center xl:flex-row xl:gap-[84px] standard:justify-center standard:gap-[116px] 2xl:gap-[194px]'>
                <div className='text-white text-center xl:text-start xl:self-center xl:max-w-[452px] standard:max-w-[552px]'>
                    <p className='headerText2 mb-4'>Transforming the Future of Digital Marketing</p>
                    <p className='bodyText2'>We're not just enhancing the digital landscape - we're reinventing it. The Eulerity platform delivers revolutionary scalability, AI-optimized efficiency, and sophisticated marketing automation for targeted impact.</p>
                </div>
                <div>
                    <video className='object-cover w-full m-auto max-w-[516px] h-auto xl:h-[396px]' autoPlay loop muted playsInline>
                        <source src={HomePageBannerVideo} type='video/mp4' />
                    </video>
                </div>
            </div>
        </section>
    )
}

export default Hero